import jsPDF from "jspdf";

const generateAdmissionForm = (student) => {
  return new Promise((resolve, reject) => {
    const doc = new jsPDF("p", "mm", "a4");

    // **Header**
    doc.setFontSize(18);
    doc.setTextColor(0, 0, 128);
    doc.text("Student Admission Form", 60, 20);

    // **Personal Details**
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    let y = 40;
    doc.text(`Name: ${student.name || "N/A"}`, 20, y);
    doc.text(`DOB: ${student.dob || "N/A"}`, 120, y);

    y += 10;
    doc.text(`Aadhaar No: ${student.aadhaar_no || "N/A"}`, 20, y);
    doc.text(`Blood Group: ${student.blood_group || "N/A"}`, 120, y);

    y += 10;
    doc.text(`Gender: ${student.gender || "N/A"}`, 20, y);
    doc.text(`Category: ${student.category || "N/A"}`, 120, y);

    // **Parent Details**
    y += 15;
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 128);
    doc.text("Parent Details", 20, y);
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    y += 10;
    doc.text(`Father's Name: ${student.fatherName || "N/A"}`, 20, y);
    doc.text(`Father Aadhaar No: ${student.f_aadhaar_no || "N/A"}`, 120, y);

    y += 10;
    doc.text(`Mother's Name: ${student.motherName || "N/A"}`, 20, y);
    doc.text(`Mother Aadhaar No: ${student.m_aadhaar_no || "N/A"}`, 120, y);

    // **Address**
    y += 15;
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 128);
    doc.text("Address Details", 20, y);
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    y += 10;
    const state = "West Bengal";
    const district = "Murshidabad";
    const block = "Beldanga I";

    doc.text(`State: ${state}`, 20, y);
    doc.text(`District: ${district}`, 120, y);

    y += 10;
    doc.text(`Block: ${block}`, 20, y);
    doc.text(`Village: ${student.village || "N/A"}`, 120, y);

    y += 10;
    doc.text(`Post Office: ${student.post_office || "N/A"}`, 20, y);
    doc.text(`Police Station: ${student.police_station || "N/A"}`, 120, y);

    y += 10;
    doc.text(`Pincode: ${student.pincode || "N/A"}`, 20, y);

    // **Academic Details**
    y += 15;
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 128);
    doc.text("Academic Details", 20, y);
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    y += 10;
    doc.text(`Class: ${student.class || "N/A"}`, 20, y);
    doc.text(`Section: ${student.section || "N/A"}`, 120, y);

    y += 10;
    doc.text(`Stream: ${student.stream || "N/A"}`, 20, y);
    doc.text(`BPL No: ${student.bpl_no || "N/A"}`, 120, y);

    // **Bank Details**
    y += 15;
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 128);
    doc.text("Bank Details", 20, y);
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    y += 10;
    doc.text(`Bank Name: ${student.banks || "N/A"}`, 20, y);
    doc.text(`Account No: ${student.account_no || "N/A"}`, 120, y);

    y += 10;
    doc.text(`IFSC Code: ${student.ifsc_code || "N/A"}`, 20, y);

    // **Handle Image**
    if (student.file) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = student.file;

      img.onload = function () {
        try {
          doc.addImage(img, "JPEG", 150, 40, 40, 40);
          doc.save("Admission_Form.pdf");
          resolve();
        } catch (error) {
          console.error("Image Error:", error);
          doc.save("Admission_Form.pdf");
          resolve();
        }
      };

      img.onerror = function () {
        console.error("Image failed to load:", student.file);
        addDefaultImage(doc); // Default Image if image fails
        doc.save("Admission_Form.pdf");
        resolve();
      };
    } else {
      addDefaultImage(doc); // Default Image if no image provided
      doc.save("Admission_Form.pdf");
      resolve();
    }
  });
};

// **Function to add default image**
const addDefaultImage = (doc) => {
  const defaultImg =
    "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD..."; // Base64 default image
  doc.addImage(defaultImg, "JPEG", 150, 40, 40, 40);
};

export default generateAdmissionForm;
